var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"ctk-summary-card-title tw-flex tw-items-center tw-bg-blue-500 tw-font-medium tw-text-center tw-text-base tw-text-white tw-rounded-sm tw-px-6",domProps:{"textContent":_vm._s(_vm.title)}})}
var staticRenderFns = []

export { render, staticRenderFns }